import { ConstProps, CONST, FETCH_CONSTANTS_REQUEST, FETCH_CONSTANTS_SUCCESS, FETCH_CONSTANTS_FAILURE } from './types'

const initialState = {
  data: undefined,
  loading: false,
  init: false,
  error: undefined,
}

export const ConstReducer = (state: ConstProps = initialState, action: CONST): ConstProps => {
  const { data } = state
  const { type, payload } = action

  switch (type) {
    case FETCH_CONSTANTS_REQUEST:
      return {
        ...state,
        loading: true,
        init: false,
      }
    case FETCH_CONSTANTS_SUCCESS:
      return {
        data: payload,
        loading: false,
        init: true,
      }

    case FETCH_CONSTANTS_FAILURE:
      return {
        data,
        loading: false,
        init: false,
        error: payload,
      }

    default:
      return state
  }
}
